//@flow
import React from 'react';
import * as Immutable from 'immutable';
import { EntityDocumentUploadCard } from './';
import { getEntitySettings } from 'common/redux/selectors/clientSelector';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'common/components/core/router';
import { Document } from 'common/models/internal/Document';

type Props = {
    entitySettings: Object,
    currentEntitySettings: string,
    documents: Immutable.List<Document>,
    onChange: (Immutable.List<Document>) => void,
    maxSize: number,
    t: string => string,
    accept: Array<string>
};
class EntityDocumentUploadList extends React.PureComponent<Props, void> {
    componentDidMount() {
        const { entitySettings, currentEntitySettings, documents } = this.props;
        const { documentSettings } = entitySettings[currentEntitySettings];
        const combinedDocuments = documentSettings.map(setting => {
            let matchingDocument = documents.find(
                currentDocument => currentDocument.type === setting.type
            );
            if (!matchingDocument) {
                matchingDocument = Document.fromJS({
                    type: setting.type,
                    id: '',
                    imageUrl: '',
                    documentId: '',
                    expiryDate: '',
                    isDocumentIdApplicable: false,
                    isMandatory: false,
                    isExpiryDateApplicable: false,
                    isMultiApplicable: false
                });
            }
            return matchingDocument
                .set('isDocumentIdApplicable', setting.isDocumentIdApplicable)
                .set('isMandatory', setting.isMandatory)
                .set('isExpiryDateApplicable', setting.isExpiryDateApplicable)
                .set('isMultiApplicable', setting.isMultiApplicable);
        });
        this.props.onChange(combinedDocuments);
    }
    onChangeHandler = doc => {
        const { documents, onChange } = this.props;
        const index = documents.findIndex(o => o.type === doc.type);
        const newDocList = documents.set(index, doc);
        onChange(newDocList);
    };
    render() {
        const { t, accept, maxSize } = this.props;
        return (
            <React.Fragment>
                {this.props.documents.map(obj => {
                    return (
                        <EntityDocumentUploadCard
                            key={obj.type}
                            currentDocument={obj}
                            onChangeHandler={this.onChangeHandler}
                            t={t}
                            accept={accept}
                            maxSize={maxSize}
                        />
                    );
                })}
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    const entitySettings = getEntitySettings(state, ownProps);

    return {
        entitySettings
    };
};

const EnhancedEntityDocumentUploadList = compose(
    withRouter,
    connect(mapStateToProps)
)(EntityDocumentUploadList);

export default EnhancedEntityDocumentUploadList;
export { EnhancedEntityDocumentUploadList as EntityDocumentUploadList };
